package com.patronat.top.features.dashboard.domain.usecase.command

data class ModerateReviewCommand(
    val reviewId: String,
    val approved: Boolean
)
